import React from 'react'

// renders a math-style expression like:  ( 162 × 0.5 ) × 12
// pass an array of tokens; numbers/strings render plain,
// operators ('×', '(', ')') render dimmed.
type Token = { type?: 'op'; value: React.ReactNode }

// helper to build operator tokens with less noise at call sites
export const op = (value: React.ReactNode): Token => ({ type: 'op', value })

const MathExpr = ({ tokens }: { tokens: Token[] }) => {
    return (
        <span
            style={{
                direction: 'ltr',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '3px',
                fontFamily: 'monospace',
                fontSize: '14px'
            }}
        >
            {tokens.map((t, i) => {
                // dim operators, plain for the rest
                let style: React.CSSProperties = {}
                if (t.type == 'op') style = { opacity: 0.7 }
                return (
                    <span key={i.toString()} style={style}>
                        {t.value}
                    </span>
                )
            })}
        </span>
    )
}

export default MathExpr
